




























































import VueOptions from '@utils/VueOptions'
import PostingPlatformsUtility from '@utils/PostingPlatformsUtility'

settings =
  name: 'FormFieldPostingPlatforms'

  vue:
    props: ['value', 'errors']

    data: ->
      platforms: @platformsToFormField(@value)

    computed:
      defaultPlatforms: ->
        PostingPlatformsUtility.getPlatformsDefaults()

    methods:
      hiAddPlatform: (name) ->
        platforms = { ...@platforms }
        platforms[name] = @makePlatformItem name
        @platforms = platforms
        @inputChanged()

      hiRemovePlatform: (name) ->
        platforms = { ...@platforms }
        delete platforms[name]
        @platforms = platforms
        @inputChanged()

      hiInputChange: ->
        @inputChanged()

      inputChanged: ->
        platformsToEmit = @platformsToEmit @platforms
        @platforms = @platformsToFormField platformsToEmit
        @$emit 'input', platformsToEmit
        @$emit 'change', platformsToEmit

      platformsToFormField: (value = {}) ->
        platforms = {}
        platforms[name] = { ...p, name } for name, p of value
        platforms

      platformsToEmit: (value = {}) ->
        platforms = {}
        platforms[name] = p for key, { name, ...p } of value
        platforms

      makePlatformItem: (name) ->
        name: name
        handle: null
        reach: null
        description: null

      isPlatformActive: (name) ->
        !!@platforms[name]

      isDefaultPlatform: (name = '') ->
        !!@defaultPlatforms[name]

      isSpecialPlatform: (name = '') ->
        !!@defaultPlatforms[name]?.special

      iconForPlatform: (name = '') ->
        @defaultPlatforms[name]?.iconClass

export default VueOptions.vue settings
